import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SearchRoutingModule } from './search-routing.module';
import { SearchHomeComponent } from './search-home/search-home.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { CompanyPscDetailsComponent } from './company-psc-details/company-psc-details.component';
import {SharedComponentsModule} from '../../../shared/shared-components/shared-components.module';
import {FormsModule} from '@angular/forms';
import {NgxSkeletonLoaderComponent} from 'ngx-skeleton-loader';

@NgModule({
  declarations: [SearchHomeComponent, SearchResultComponent, CompanyPscDetailsComponent],
  imports: [CommonModule, SearchRoutingModule, SharedComponentsModule, FormsModule, NgxSkeletonLoaderComponent],
})
export class SearchModule {}
